import * as _ from 'lodash';
import { ErrorInfo } from './ErrorInfo';
import { parseError } from './errorParser';

angular.module('twshared').provider('ergoErrorParser', [function ergoErrorParserProvider() {

    var provider = this;
    this.parse = null;
    this.$get = [function ergoErrorParserFactory() {
        return function (err) {
            if (err instanceof ErrorInfo) {
                return err;
            }

            let ei = null;

            if (provider.parse != null) {
                let res = provider.parse(err);
                if (res instanceof ErrorInfo) {
                    ei = res;
                }
            }

            if (ei == null) {
                ei = parseError(err);
            }


            if (ei.source == null) {
                ei.source = err;
            }

            return ei;
        };
    }];
}]);
